(() => {
  if (window.__simpleWishlistInitialized) return;
  window.__simpleWishlistInitialized = true;

  const STORAGE_KEY = 'abstractstate:wishlist:v1';
  let overlay;
  let itemsContainer;
  let headerButton;
  let headerCount;

  const normalizeUrl = (url) => {
    try {
      const parsed = new URL(url, window.location.origin);
      return parsed.pathname.replace(/\/$/, '');
    } catch (error) {
      return String(url || '').replace(/\/$/, '');
    }
  };

  const read = () => {
    try {
      const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(value) ? value : [];
    } catch (error) {
      return [];
    }
  };

  const write = (items) => {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); } catch (error) {}
    sync();
  };

  const productHandle = (url) => {
    const path = normalizeUrl(url);
    const marker = '/products/';
    const index = path.indexOf(marker);
    if (index < 0) return path;
    return path.slice(index + marker.length).split('/')[0] || path;
  };

  const publishWishlistEvent = (eventName, data, wishlistCount) => {
    const payload = {
      item_id: productHandle(data.url),
      item_name: data.title || '',
      item_url: normalizeUrl(data.url),
      price_text: data.price || '',
      wishlist_count: wishlistCount,
      source_path: window.location.pathname
    };

    try {
      const published = window.Shopify?.analytics?.publish?.(`bfractal:${eventName}`, payload);
      if (published?.catch) published.catch(() => {});
    } catch (error) {}

    const gaPayload = {
      items: [{ item_id: payload.item_id, item_name: payload.item_name }],
      wishlist_count: payload.wishlist_count,
      item_url: payload.item_url,
      source_path: payload.source_path
    };

    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, gaPayload);
      } else if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push({ event: eventName, ...gaPayload });
      }
    } catch (error) {}
  };

  const isFavorite = (url) => {
    const key = normalizeUrl(url);
    return read().some((item) => normalizeUrl(item.url) === key);
  };

  const cardData = (wrapper, link) => {
    const image = wrapper.querySelector('.card__media img');
    const price = wrapper.querySelector('.price-item--sale, .price__regular .price-item--regular, .price-item--regular');
    return {
      url: normalizeUrl(link.href),
      title: link.textContent.trim(),
      image: image?.currentSrc || image?.src || '',
      price: price?.textContent?.replace(/\s+/g, ' ').trim() || ''
    };
  };

  const setButtonState = (button) => {
    const active = isFavorite(button.dataset.productUrl);
    button.classList.toggle('is-favorite', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.setAttribute('aria-label', `${active ? 'Remove' : 'Add'} ${button.dataset.productTitle || 'product'} ${active ? 'from' : 'to'} favorites`);
  };

  const toggle = (data) => {
    const key = normalizeUrl(data.url);
    let items = read();
    const index = items.findIndex((item) => normalizeUrl(item.url) === key);

    if (index >= 0) {
      const removed = items[index];
      items.splice(index, 1);
      write(items);
      publishWishlistEvent('remove_from_wishlist', removed, items.length);
      return;
    }

    const added = { ...data, url: key };
    items.unshift(added);
    write(items);
    publishWishlistEvent('add_to_wishlist', added, items.length);
  };

  const makeCardButton = (wrapper) => {
    if (wrapper.querySelector('[data-card-wishlist]')) return;
    const cover = wrapper.querySelector('.card__inner');
    const link = wrapper.querySelector('.card__heading a[href*="/products/"]');
    if (!cover || !link) return;

    const data = cardData(wrapper, link);
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'card-wishlist';
    button.dataset.cardWishlist = '';
    button.dataset.productUrl = data.url;
    button.dataset.productTitle = data.title;
    button.setAttribute('aria-pressed', 'false');
    button.innerHTML = '<svg viewBox="0 0 32 32" aria-hidden="true"><path d="M16 27.2S4.5 20.4 4.5 11.7A6.7 6.7 0 0 1 16 7.1a6.7 6.7 0 0 1 11.5 4.6C27.5 20.4 16 27.2 16 27.2Z"/></svg>';
    setButtonState(button);

    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      toggle(cardData(wrapper, link));
    });
    button.addEventListener('pointerdown', (event) => event.stopPropagation());
    cover.appendChild(button);
  };

  const scan = (root = document) => root.querySelectorAll('.product-card-wrapper').forEach(makeCardButton);

  const escapeHtml = (value) => String(value || '').replace(/[&<>'"]/g, (char) => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[char]));

  const renderDrawer = () => {
    if (!itemsContainer) return;
    const items = read();
    if (!items.length) {
      itemsContainer.innerHTML = '<div class="wishlist-drawer__empty"><strong>No favorites yet</strong>Tap the heart on any pack to save it here.</div>';
      return;
    }
    itemsContainer.innerHTML = items.map((item) => `
      <div class="wishlist-drawer__item" data-wishlist-url="${escapeHtml(item.url)}">
        <a href="${escapeHtml(item.url)}"><img class="wishlist-drawer__image" src="${escapeHtml(item.image)}" alt=""></a>
        <div class="wishlist-drawer__meta">
          <a class="wishlist-drawer__name" href="${escapeHtml(item.url)}">${escapeHtml(item.title)}</a>
          ${item.price ? `<span class="wishlist-drawer__price">${escapeHtml(item.price)}</span>` : ''}
        </div>
        <button class="wishlist-drawer__remove" type="button" data-wishlist-remove="${escapeHtml(item.url)}" aria-label="Remove ${escapeHtml(item.title)} from favorites"><svg viewBox="0 0 32 32" aria-hidden="true"><path d="M16 27.2S4.5 20.4 4.5 11.7A6.7 6.7 0 0 1 16 7.1a6.7 6.7 0 0 1 11.5 4.6C27.5 20.4 16 27.2 16 27.2Z"/></svg></button>
      </div>`).join('');
  };

  const updateHeader = () => {
    if (!headerButton || !headerCount) return;
    const count = read().length;
    headerCount.textContent = String(count);
    headerCount.hidden = count === 0;
    headerButton.classList.toggle('has-favorites', count > 0);
    headerButton.setAttribute('aria-label', `Favorites${count ? ` (${count})` : ''}`);
  };

  const openDrawer = () => {
    renderDrawer();
    overlay?.classList.add('is-open');
    document.body.classList.add('overflow-hidden');
    overlay?.querySelector('.wishlist-drawer__close')?.focus();
  };

  const closeDrawer = () => {
    overlay?.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
    headerButton?.focus();
  };

  const mountDrawer = () => {
    if (overlay) return;
    overlay = document.createElement('div');
    overlay.className = 'wishlist-drawer-overlay';
    overlay.innerHTML = '<aside class="wishlist-drawer" role="dialog" aria-modal="true" aria-label="Favorites"><div class="wishlist-drawer__header"><h2 class="wishlist-drawer__title"><span>♥</span> Favorites</h2><button class="wishlist-drawer__close" type="button" aria-label="Close favorites">×</button></div><div class="wishlist-drawer__items"></div></aside>';
    document.body.appendChild(overlay);
    itemsContainer = overlay.querySelector('.wishlist-drawer__items');
    overlay.querySelector('.wishlist-drawer__close').addEventListener('click', closeDrawer);
    overlay.addEventListener('click', (event) => { if (event.target === overlay) closeDrawer(); });
    overlay.addEventListener('click', (event) => {
      const remove = event.target.closest('[data-wishlist-remove]');
      if (!remove) return;
      const url = remove.dataset.wishlistRemove;
      const item = read().find((entry) => normalizeUrl(entry.url) === normalizeUrl(url));
      if (item) toggle(item);
    });
  };

  const mountHeaderButton = () => {
    if (document.querySelector('[data-header-wishlist]')) return;
    const cart = document.querySelector('#cart-icon-bubble');
    if (!cart?.parentNode) return;
    headerButton = document.createElement('button');
    headerButton.type = 'button';
    headerButton.className = 'header__icon link focus-inset header-wishlist-button';
    headerButton.dataset.headerWishlist = '';
    headerButton.innerHTML = '<svg class="header-wishlist-heart" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78z"/></svg><span class="header-wishlist-count cart-count-bubble" hidden></span>';
    headerButton.addEventListener('click', openDrawer);
    cart.parentNode.insertBefore(headerButton, cart);
    headerCount = headerButton.querySelector('.header-wishlist-count');
    updateHeader();
  };

  const sync = () => {
    document.querySelectorAll('[data-card-wishlist]').forEach(setButtonState);
    updateHeader();
    renderDrawer();
  };

  const start = () => {
    mountDrawer();
    mountHeaderButton();
    scan();
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && overlay?.classList.contains('is-open')) closeDrawer(); });
    window.addEventListener('storage', (event) => { if (event.key === STORAGE_KEY) sync(); });
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (node.matches('.product-card-wrapper')) makeCardButton(node);
          scan(node);
        }
      }
      if (!document.querySelector('[data-header-wishlist]')) mountHeaderButton();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
